const HomeAppPhoneMock = () => (
  <div className="home-app-phone">
    <div className="home-app-phone-screen">
      <div className="home-app-phone-status" aria-hidden="true">
        <span>9:41</span>
        <span className="home-app-phone-status-icons">
          <i className="fas fa-signal"></i>
          <i className="fas fa-wifi"></i>
          <i className="fas fa-battery-full"></i>
        </span>
      </div>
      <div className="home-app-phone-body">
        <div className="home-app-phone-brand">
          <img src="/coown-logo-mark.svg" alt="" width="52" height="52" />
          <strong>CoOwn</strong>
          <span>Fractional real estate &amp; rentals</span>
        </div>
        <div className="home-app-phone-cards">
          <div className="home-app-phone-card">
            <div className="home-app-phone-card-thumb" style={{ backgroundImage: "linear-gradient(135deg, rgba(212,176,111,0.25), rgba(11,31,42,0.5)), url(https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&q=60) center/cover" }}></div>
            <div className="home-app-phone-card-title">Lekki Phase 1 Apartments</div>
            <div className="home-app-phone-card-meta">
              <span>For sale · 12% est.</span>
              <span>$500 min</span>
            </div>
          </div>
          <div className="home-app-phone-card">
            <div className="home-app-phone-card-thumb" style={{ backgroundImage: "linear-gradient(135deg, rgba(42,157,143,0.3), rgba(11,31,42,0.5)), url(https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=400&q=60) center/cover" }}></div>
            <div className="home-app-phone-card-title">Downtown condo · For rent</div>
            <div className="home-app-phone-card-meta">
              <span>$3,200/mo</span>
              <span>2 bed</span>
            </div>
          </div>
        </div>
      </div>
      <nav className="home-app-phone-tabs" aria-hidden="true">
        <div className="home-app-phone-tab home-app-phone-tab--active">
          <i className="fas fa-home"></i>
          <span>Home</span>
        </div>
        <div className="home-app-phone-tab">
          <i className="fas fa-key"></i>
          <span>Rent</span>
        </div>
        <div className="home-app-phone-tab">
          <i className="fas fa-chart-pie"></i>
          <span>Portfolio</span>
        </div>
        <div className="home-app-phone-tab">
          <i className="fas fa-user"></i>
          <span>Profile</span>
        </div>
      </nav>
    </div>
  </div>
);

const HomeAppSection = () => (
  <section className="home-app" aria-labelledby="home-app-heading">
    <div className="home-app-inner">
      <div className="home-app-copy">
        <h2 id="home-app-heading">
          <span className="home-app-dot" aria-hidden="true"></span>
          CoOwn mobile app
        </h2>
        <p>
          Invest and track listings from anywhere. Manage favorites, follow funding progress, and
          get project updates. Coming soon to iOS and Android.
        </p>
        <div className="home-app-badges">
          <span className="home-app-badge" title="Coming soon">
            <i className="fab fa-apple"></i> App Store (soon)
          </span>
          <span className="home-app-badge" title="Coming soon">
            <i className="fab fa-google-play"></i> Google Play (soon)
          </span>
        </div>
      </div>
      <div className="home-app-visual">
        <HomeAppPhoneMock />
      </div>
    </div>
  </section>
);

export { HomeAppPhoneMock };
export default HomeAppSection;
